import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { RespondButton } from '@/components/Post/components/RespondButton';
import { ThumbsUpIcon } from '@/imports/ui/chakra/feather';
import { DataPhTags } from '@/analytics';

import { PostLikeButton_PostFragment } from './graphql-types/PostLikeButton_PostFragment';

import { usePostLike } from './hooks/usePostLike';

export const PostLikeButton: React.FC<{
  post: PostLikeButton_PostFragment;
  onClickOverride?: () => void;
}> & {
  postFragment: DocumentNode;
} = ({ post, onClickOverride }) => {
  const { handleLikeClick, isLoading } = usePostLike(post);
  const isLiked = post.currentUserReaction?.reactionType === 'LIKE';
  return (
    <>
      <RespondButton
        data-ph={DataPhTags.POST_LIKE}
        onClick={onClickOverride ? onClickOverride : handleLikeClick}
        color={isLiked ? 'primary.500' : 'gray.600'}
        leftIcon={<ThumbsUpIcon isLiked={isLiked} />}
        isDisabled={isLoading}
      >
        Like
      </RespondButton>
    </>
  );
};

PostLikeButton.postFragment = gql`
  fragment PostLikeButton_PostFragment on PostV2 {
    _id
    currentUserReaction {
      _id
      reactionType
    }
    ...usePostLike_PostFragment
  }
  ${usePostLike.postFragment}
`;
